import { ListSubheader, ListSubheaderProps, Typography } from '@mui/material';
import React from 'react';
import {
  SETTINGS_SUBHEADER_DESKTOP_MARGIN_BOTTOM,
  SETTINGS_SUBHEADER_TABLET_MOBILE_MARGIN_BOTTOM,
} from 'themes/constants';

type SettingsListSubheaderProps = ListSubheaderProps & {
  isDesktop: boolean;
};

export const SettingsListSubheader = ({
  isDesktop,
  children,
  ...rest
}: SettingsListSubheaderProps) => {
  const color = isDesktop ? 'grey.800' : 'primary';
  // Use larger margin for desktop to maintain visual spacing, smaller for tablet/mobile for compactness
  const marginBottom = isDesktop
    ? SETTINGS_SUBHEADER_DESKTOP_MARGIN_BOTTOM
    : SETTINGS_SUBHEADER_TABLET_MOBILE_MARGIN_BOTTOM;

  return (
    <ListSubheader {...rest}>
      <Typography
        variant="h6"
        color={color}
        fontWeight={500}
        marginBottom={marginBottom}
        aria-hidden="true"
      >
        {children}
      </Typography>
    </ListSubheader>
  );
};
